module.exports = __webpack_public_path__ + "img/logo.d031d509.png";